import { EReceiverTypeAgent, EReferralForm } from '../enum/prospect-referral.enum';

export type ProspectReferralFormState = {
  _id?: string | null;
  title: string;
  bannerImg: ImageItem | null;
  introduction: string;
  additionalInformation: string;
  tabs: {
    tabTitle: string;
    tabDescription: string;
  }[];
  referralForm: {
    isName: boolean;
    isPhone: boolean;
    isProvinceCity: boolean;
    isDob: boolean;
    isEmail: boolean;
  };
  leadDistributionRule: {
    campaignId: string;
  };
  agentSegment: AgentSegment;
  status?: string;
  webflowLink?: string;
};

export type ImageItem = {
  id: string;
  fileName: string;
  url: string;
  type: string;
  importId: string;
};

export type FileType = {
  blobId: string;
  fileName: string;
  url: string;
  type: string;
};

export type AgentSegment = {
  isTraditionalAgents: boolean;
  isPruventure: boolean;
  isGroupOfUsers: boolean;
  userFile: FileType | null;
  userList: string[];
};

export const MentionList = [
  { id: 'agentCode', display: 'agentcode' },
  { id: 'agentName', display: 'agentname' },
];

export const ReferralFormOption = [
  { value: false, key: EReferralForm.isName, isRequired: true, label: 'Họ Tên' },
  { value: false, key: EReferralForm.isPhone, isRequired: true, label: 'Số Điện Thoại' },
  { value: false, key: EReferralForm.isProvinceCity, isRequired: false, label: 'Tỉnh/Thành Phố Đang Sinh Sống' },
  { value: false, key: EReferralForm.isDob, isRequired: false, label: 'Ngày Sinh' },
  { value: false, key: EReferralForm.isEmail, isRequired: false, label: 'Email' },
];

export const AgentSegmentOptions = [
  { value: false, key: EReceiverTypeAgent.isTraditionalAgents, label: 'All Traditional Agents' },
  { value: false, key: EReceiverTypeAgent.isPruventure, label: 'Full time Agents' },
  { value: false, key: EReceiverTypeAgent.isGroupOfUsers, label: 'Group of Users', isUpload: true },
];
